<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'md'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="px-3">
            <div class="row mx-0 px-0">
                <div class="mb-2 col-xl-12 px-1">
                    <label for="name" class="form-label">Nombre</label>
                    <input type="text" class="form-control form-control-sm" v-model="name" placeholder=" Nombre">
                </div>
            </div>
        </div>
        <template #footer>
            <button class="btn btn-success btn-sm" @click="DataDetail" :disabled="cpButton">
                Registrar
            </button>
        </template>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {mapActions} from "vuex";

export default {
    name: "c-maintenance-modal-documento",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            name: '',
        };
    },
    watch: {
    },
    props: {
        title: String,
        boo_modal: Boolean,
        id: Number,
    },
    computed: {
        cpButton() {
            return !(this.name.trim() !== '');
        }
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdClose() {
            this.name ='';
            this.$emit("mtdCloseModalPlus");
        },
        DataDetail() {
            this.registerData(this.name, this.id);
        },

        registerData: function (payload_detail, id) {
            this.$refs.SweetAlert.showConfirmSimple2("","¿Estás seguro?","warning","Confirmar") 
            .then((result) => {
                if (result.value) {
                    this.addDatadetail(payload_detail, id);
                }
            });
        },

        addDatadetail: function (payload_detail, id) {
            this.post({
                url: this.$store.getters.get__url + "/Active/registerBrand",
                token: this.$store.getters.get__token,
                params: {
                    payload_detail: payload_detail,
                    id: id
                },
            })
            .then(response => {
                if(response.statusCode == 200){
                    if(response.data.state == 0){
                        this.$refs.SweetAlert.showSuccess("Registro Exitoso");
                        this.mtdClose();
                    }else{
                        this.$refs.SweetAlert.showWarning("Ya existe esa Marca Registrada");
                        this.name ='';
                    }
                }else{
                    this.$refs.SweetAlert.showError("Error");
                }
                
            })
            .catch(error => {
                this.$refs.SweetAlert.showError(error);
            })
        },
    },
    

};
</script>